import { Outlet } from "react-router-dom";
import { PublicHeader } from "@/components/PublicHeader";
import { PublicFooter } from "@/components/PublicFooter";
import { CookieBanner } from "@/components/CookieBanner";
import { WhatsAppButton } from "@/components/WhatsAppButton";

export default function PublicLayout() {
  return (
    <div className="bg-navy-900 min-h-screen">
      <PublicHeader />
      <main><Outlet /></main>
      <PublicFooter />
      <CookieBanner />
      <WhatsAppButton />
    </div>
  );
}
